<div class="custom-snackba {{data.className}}">
    <div class="icon">
      <span *ngIf="!data.icon"><fa-icon [icon]="faCancel"></fa-icon></span>
      <span *ngIf="data.icon"><fa-icon [icon]="faCheck"></fa-icon></span>
    </div>
    <div class="message">
      <p>{{ data.message }}</p>
    </div>
  </div>

